module.exports = __webpack_public_path__ + "static/hero.ee30b263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rooms/hero.jpg
// module id = 631
// module chunks = 7134270256118